<template>
    <div class="a">
        <top></top>
        <navs></navs>
        <div class="content">
            <div class="time">
                <div class="cont">
                    <div class="cont_a">
                        <div class="bule"></div>
                        <div class="p">直播时间</div>
                    </div>
                    <div class="image">
                        <img :src="zimage" alt="" style="width: 100%;">
                    </div>
                    <div class="cont_a">
                        <div class="bule"></div>
                        <div class="p">聚会时间</div>
                    </div>
                    <div class="image">
                        <img :src="jimage" alt="" style="width: 100%;">
                    </div>
                </div>
            </div>
        </div>
        <bottom></bottom>
    </div>
</template>
<script>
import {jtime,ztime} from "@/api/index.js"
import top from "@/components/top.vue"
import bottom from "@/components/bottom.vue"
import navs from "@/components/navs.vue"
export default {
    components: {
        top,
        bottom,
        navs
    },
    created(){
        jtime().then(res=>{
            console.log(res)
            this.jimage = res.data.data.image1
        })
        ztime().then(res=>{
            this.zimage = res.data.data.image1
        })
    },
    data(){
        return{
            jimage:"",
            zimage:""
        }
        
    }
}
</script>
<style scoped>
.a {
    width: 100%;
    /* height: 100vh; */
    margin: 0;
    padding: 0;
    background-color: #F7F7F7;
}
.content{
    width: 100%;
    /* height: 1330px; */
    background-image: url(../image/back.png);
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
}
.time{
    width: 70%;
    margin: 0 auto;
    /* height: 1330px; */
    background-color: #F7F7F7;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.bule{
    width: 5px;
height: 16px;
background: #1463FF;
}
.p{
    margin-left: 5px;
    font-family: PingFangSC, PingFang SC;
font-weight: 500;
font-size: 17px;
color: #333333;
line-height: 17px;
font-style: normal;
}
.cont{
    width: 80%;
    margin: 0 auto;

}
.cont_a{
    height: 74px;
    display: flex;
    align-items: center;
}
.image{
    width: 100%;
    margin-bottom: 32px;
}
</style>


// WEBPACK FOOTER //
// src/views/time.vue